var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 48,
    viewBox: "0 0 140 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16301_289273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35.0704C0 34.4017 0.334202 33.7772 0.890599 33.4063L43.8906 4.7396C44.5624 4.29173 45.4376 4.29173 46.1094 4.7396L89.1094 33.4063C89.6658 33.7772 90 34.4017 90 35.0704V92C90 93.1046 89.1046 94 88 94H2C0.89543 94 0 93.1046 0 92V35.0704Z",
    fill: "#DBD6FD",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 35.0704C28 34.4017 28.3342 33.7772 28.8906 33.4063L71.8906 4.7396C72.5624 4.29173 73.4376 4.29173 74.1094 4.7396L117.109 33.4063C117.666 33.7772 118 34.4017 118 35.0704V92C118 93.1046 117.105 94 116 94H30C28.8954 94 28 93.1046 28 92V35.0704Z",
    fill: "#DBD6FD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 35.0704C61 34.4017 61.3342 33.7772 61.8906 33.4063L104.891 4.7396C105.562 4.29173 106.438 4.29173 107.109 4.7396L150.109 33.4063C150.666 33.7772 151 34.4017 151 35.0704V92C151 93.1046 150.105 94 149 94H63C61.8954 94 61 93.1046 61 92V35.0704Z",
    fill: "#DBD6FD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 35.0704C89.5 34.5688 89.7507 34.1005 90.1679 33.8223L133.168 5.15562C133.672 4.81973 134.328 4.81973 134.832 5.15563L177.832 33.8223C178.249 34.1005 178.5 34.5688 178.5 35.0704V92C178.5 92.8284 177.828 93.5 177 93.5H91C90.1716 93.5 89.5 92.8284 89.5 92V35.0704Z",
    stroke: "#DBD6FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19,
    width: 159,
    height: 48,
    fill: "url(#paint0_linear_16301_289273)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16301_289273",
    x1: 60.5,
    y1: 0,
    x2: 60.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16301_289273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBig);
export default __webpack_public_path__ + "static/media/EmailBig.a68c2ab4785df2f59ed4bf4deed964d8.svg";
export { ForwardRef as ReactComponent };